import React, { useEffect, useState } from 'react'
import { Box, Link, Typography } from '@mui/material';

export interface NewExperienceDto {
    role: string;
    company: string;
    location: string;
    startDate: string;
    endDate: string;
    description: string;
    achievements?: string;
    webSite?: string;
}

const experiences: NewExperienceDto[] = [
    {
        role: "Software Developer",
        company: "Ontime (Startup)",
        location: "Victoria, BC and Tehran",
        startDate: "November 2019",
        endDate: 'Present',
        description: `Led end-to-end development of a web-based appointment scheduling platform, enabling medical offices, salons, and other service-based businesses to efficiently manage bookings, reduce scheduling conflicts, and streamline operations.
Architected and maintained the backend (ASP.NET Core, SQL Server) and frontend (React.js, TypeScript, Material-UI) to ensure a responsive and scalable platform.
Developed reporting and analytics dashboards, enabling businesses to track appointments, payments, and customer loyalty metrics efficiently.
`,
        achievements: `Reduced scheduling errors by 30%, improving appointment accuracy and minimizing manual booking mistakes.
Enhanced scalability by 40%, enabling the platform to support more clients without performance issues.
Accelerated system performance by 25%, reducing API response times by optimizing data fetching, and improving user experience and system efficiency.
`,
        webSite: "https://www.0ntime.ir/"
    },
    {
        role: "Software Developer",
        company: "Charisma",
        location: "Tehran",
        startDate: "February 2021",
        endDate: "November 2022",
        description: `Developed and maintained backend and frontend components for high-traffic FinTech applications, improving system efficiency and scalability.
Implemented secure authentication and encryption protocols, reducing vulnerabilities and ensuring compliance with industry standards.
Optimized banking API integrations, enabling faster and more reliable connections to multiple financial institutions.
Mentored junior developers, fostering a collaborative environment and improving team productivity.
`,
        achievements: `Reduced transaction processing time by 25%, enhancing system performance and reliability.
Accelerated new bank API integrations, improving onboarding efficiency and reducing development time.
Optimized frontend performance, increasing customer satisfaction by 15% through faster load times and improved user experience.
`,
        webSite: "https://charisma.ir/",
    },
    {
        role: "Software Developer",
        company: "Refah Bank",
        location: "Tehran",
        startDate: "January 2018",
        endDate: "February 2021",
        description: `Developed responsive single-page applications for banking services using ReactJS, and Angular.
Created and optimized RESTful APIs with ASP.NET Core.
Played a key role in migrating legacy systems to modern frameworks, reducing technical debt.
`,
        achievements: `Enhanced user experience with a 30% reduction in page load times.
Reduced system vulnerabilities by 40% through collaborative security efforts.
`,
        webSite: "https://refah-td.com/"
    },
    {
        role: "Software Developer",
        company: "Narm Negaran Pishro",
        location: "Tehran",
        startDate: "October 2015",
        endDate: "January 2018",
        description: `Collaborated on the development of an HR management platform that streamlined employee records, payroll processing, and report generation.`,
        webSite: "http://narmnegaran.com/",
    },
    {
        role: "Software Developer",
        company: "Persian Technology",
        location: "Tehran",
        startDate: "September 2014",
        endDate: "October 2015",
        description: `Enhanced .NET Framework and C# skills while working on communication with physical devices.`,
        webSite: "https://parsiansoftware.com/",
    },
    {
        role: "Software Developer",
        company: "Jahan Gostar",
        location: "Tehran",
        startDate: "December 2013",
        endDate: "September 2014",
        description: `Developed Windows applications using C#, .NET Framework, and SQL, integrating attendance device communication.`,
        webSite: "https://www.jahan-gostar.com/",
    },
];

export const languageData = [
    {
        id: "ReactJS",
        title: "React JS",
        webSite: "https://reactjs.org/",
    },
    { id: "Redux" },
    { id: "MaterialUI" },
    {
        id: "HTML",
        title: "HTML",
        webSite: "https://html.com/",
    },
    {
        id: "CSS",
        title: "CSS",
        webSite: "https://developer.mozilla.org/en-US/docs/Web/CSS",
    },
    { id: "Sass" },

    {
        id: "JavaScript",
        title: "Java Script",
        webSite: "https://www.javascript.com/",
    },
    { id: "TypeScript" },
    {
        id: "ASPDotNet",
        title: "Microsoft ASP.Net",
        webSite: "https://docs.microsoft.com/en-us/aspnet/core/?view=aspnetcore-6.0",
    },
    {
        id: "ASPDotNetCore",
        title: "Microsoft ASP.Net Core",
        webSite: "https://docs.microsoft.com/en-us/aspnet/core/?view=aspnetcore-3.1",
    },
    {
        id: "ASPDotNetFramework",
        title: "Microsoft ASP.Net Framework",
        webSite: "https://docs.microsoft.com/",
    },
    { id: "CSharp" },
    // {
    //     id: "Bootstrap",
    //     title: "Bootstrap",
    //     webSite: "https://getbootstrap.com/",
    // },

    // {
    //     id: "CWindowsForm",
    //     title: "Microsoft C# Windows Form",
    //     webSite: "https://docs.microsoft.com/",
    // },
    {
        id: "SQLDB",
        title: "Microsoft SQL Server",
        webSite: "https://www.microsoft.com/en-us/sql-server",
    },
    {
        id: "ElasticSearch",
        title: "Elastic Search",
        webSite: "https://www.elastic.co/",
    },
    // {
    //     id: "Ionic",
    //     title: "Ionic",
    //     webSite: "https://ionicframework.com/",
    // },

    // {
    //     id: "JQuery",
    //     title: "jQuery",
    //     webSite: "https://jquery.com/",
    // },

    // {
    //     id: "ReactNative",
    //     title: "React Native",
    //     webSite: "https://reactnative.dev/",
    // },
    { id: "Git" },
    { id: "Github" },
    { id: "VisualStudio" },
    { id: "AWS" },

];

interface Props {
    scrollY: number;
    windowSize: {
        width: number;
        height: number;
    };
}

const Experience: React.FC<Props> = ({ scrollY, windowSize }) => {

    const [position, setPosition] = useState<"relative" | "fixed">("relative")//fixed//static//relative//absolute//sticky
    const [justifyContent, setJustifyContent] = useState<"flex-start" | "flex-end">("flex-start")//flex-end//flex-start

    const distance = 75;
    const imageSizeHeight = 500;
    const backColor = 'var(--backColor)';

    const height = (((experiences.length * distance) - distance) * ((imageSizeHeight / distance)) + (distance * experiences.length));

    const setId = (): string => {
        return `my-experiences`;
    };

    const startItem = (): number | undefined => {
        return document.getElementById(setId())?.offsetTop;
    };

    const EndItem = (): number | undefined => {
        const start = startItem();
        if (start === undefined) return 0;
        return start + height;
    };

    const itemScrollHeight = (): number => {
        return height + windowSize.height;
    };

    const scrollinItem = (): number => {
        return scrollY - (startItem() ?? 0);
    };

    const locationItem = (item: number): number => {
        return startSheetItem(item) - scrollinItem();
    }


    const setScrollItem = (item: number): number => {
        const loc = locationItem(item);

        if (loc <= startSheet()) {
            return startSheet();
        }
        else {
            return loc;
        }
    };

    const setOpacityItem = (item: number): number => {

        const loc = locationItem(item);

        if (loc <= startSheet()) {
            if (item === (experiences.length - 1)) {
                return 1;
            }
            else {
                return ((loc + startSheet()) / 100);
            }
        }
        else {
            return 1;
        }
    };

    const setZommItem = (item: number): boolean => {
        const loc = locationItem(item);
        if (loc <= startSheet()) {
            return true;
        }
        else {
            return false;
        }
    }

    const startSheet = (): number => {
        return 150;
    }

    const startSheetItem = (input: number): number => {
        return (windowSize.height / 2) + ((input * (imageSizeHeight + distance)) - startSheet());
    }


    useEffect(() => {

        if (scrollY < (startItem() ?? 0)) {
            setPosition("relative")
            setJustifyContent("flex-start")
        }
        else if (scrollY > (EndItem() ?? 0)) {
            setPosition("relative")
            setJustifyContent("flex-end")
        }
        else {
            setPosition("fixed")
            setJustifyContent("flex-start")
        }
    }, [scrollY, windowSize.height]);

    return (
        <>
            <Box sx=
                {{
                    height: '100vh',
                    width: '100vw',
                    position: 'fixed',
                    backgroundAttachment: { xs: 'scroll', md: 'fixed' },
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundImage: `url(experience.jpg)`,
                    zIndex: '0',
                    bottom: '0px',
                }} />
            <Box
                component="section"
                sx=
                {{
                    display: 'flex',
                    flexDirection: 'column',
                    height: itemScrollHeight(),
                    minHeight: itemScrollHeight(),
                    justifyContent: justifyContent,
                    zIndex: '1',
                }}
                id={setId()}
            >
                <Typography variant="h4" align="center"
                    sx={{
                        position: position,
                        fontWeight: "bold",
                        zIndex: '100',
                        top: '50px',
                        width: '100%'
                    }} >
                    Experiences
                </Typography>
                <div
                    style={{
                        position: position,
                        height: windowSize.height,
                        zIndex: 50,
                    }}>
                    {experiences.map((experienceItem, experienceIndex) => (
                        <Box key={experienceIndex} className="ShowExperienceWithScrollItem"
                            sx={{
                                position: (position === "relative" ? "absolute" : position),
                                top: `${setScrollItem(experienceIndex)}px`,
                                opacity: setOpacityItem(experienceIndex),
                                transform: `scale(${setZommItem(experienceIndex) ? 0.9 : 1})`,
                                zIndex: experienceIndex,
                                overflow: 'hidden',
                                backgroundColor: '#dde3e1',
                                left: { xs: 'calc(7% - 15px)', md: 'calc(20% - 40px)' },
                                height: 'auto',
                                width: { xs: '86%', md: '60%' },
                                padding: { xs: '15px', md: '40px' },
                                borderRadius: '10px'
                            }}>
                            <Typography variant='h6' >
                                {experienceItem.role}
                            </Typography>
                            <Box display='flex' alignItems='flex-end' >
                                <Link href={experienceItem.webSite} target="_blank" sx={{ color: 'text.primary' }} aria-label="LinkedIn">
                                    <Typography variant='body1' >
                                        {`${experienceItem.company}`}
                                    </Typography>
                                </Link>
                                <Typography variant='body2' ml='4px' >{`- ${experienceItem.location}`}</Typography>
                            </Box>

                            <Typography variant='body2' >{experienceItem.startDate} - {experienceItem.endDate}</Typography>
                            {experienceItem.description.split("\n").map((desc, descIndex) =>
                                desc && <Box key={descIndex} display='flex' gap={1}>
                                    <Typography variant='caption' >   {'•'}</Typography>
                                    <Typography variant='caption' >{desc}</Typography>
                                </Box>
                            )}
                            {experienceItem.achievements && <Box display='flex' gap={1}>
                                <Typography variant='caption' >   {'•'} </Typography>
                                <Typography variant='caption' >Achievements</Typography>
                            </Box>}
                            {experienceItem.achievements && experienceItem.achievements.split("\n").map((achievement, achievementIndex) =>
                                achievement && <Box ml='20px' key={achievementIndex} display='flex' gap={1} >
                                    <Typography variant='caption' >  {'o'}</Typography>
                                    <Typography variant='caption' >{achievement}</Typography>
                                </Box>
                            )}
                        </Box>

                    ))}
                </div>
            </Box>
        </>
    )
}
export default Experience
